import { render, staticRenderFns } from "./RedPacketPane.vue?vue&type=template&id=335529c2&scoped=true"
import script from "./RedPacketPane.vue?vue&type=script&lang=js"
export * from "./RedPacketPane.vue?vue&type=script&lang=js"
import style0 from "./RedPacketPane.vue?vue&type=style&index=0&id=335529c2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "335529c2",
  null
  
)

export default component.exports